import React from 'react';
import { useParams } from 'react-router-dom';
import { useAssetContext } from '../contexts/AssetContext';
import GroupedAssetView from './GroupedAssetView';
import HyperliquidDetails from './HyperliquidDetails';
import OKXDetails from './OKXDetails';
import PolymarketView from './PolymarketView';

const DetailView = () => {
  const { source } = useParams();
  const { state } = useAssetContext();

  // Filter assets based on the source parameter
  const sourceAssets = state.assets.filter(asset => 
    asset.source.startsWith(source)
  );

  const renderContent = () => {
    switch (source) {
      case 'hyperliquid':
        // Get all Hyperliquid-related assets (spot, perpetual, positions)
        const hyperliquidAssets = state.assets.filter(asset => 
          asset.source.startsWith('hyperliquid')
        );

        // Group them by type for the detailed view
        const spotAssets = hyperliquidAssets.filter(a => a.source.includes('spot'));
        const perpetualAssets = hyperliquidAssets.filter(a => a.source.includes('perpetual'));
        const positionAssets = hyperliquidAssets.filter(a => a.source.includes('position'));

        const hyperliquidData = {
          spot: spotAssets.map(asset => ({
            coin: asset.symbol,
            amount: asset.amount,
            usdValue: asset.value,
            price: asset.price
          })),
          perpetual: perpetualAssets.map(asset => ({
            coin: asset.symbol,
            amount: asset.amount,
            usdValue: asset.value,
            price: asset.price
          })),
          positions: positionAssets.map(asset => ({
            coin: asset.symbol,
            side: asset.amount >= 0 ? 'LONG' : 'SHORT', // Determine side based on amount
            size: Math.abs(asset.amount),
            entryPrice: asset.entryPrice, // Use the correct field from API response
            positionValue: asset.positionValue, // Add position value
            markPrice: asset.markPrice, // Use the correct field from API response
            unrealizedPnL: asset.unrealizedPnL,
            leverage: asset.leverage, // Use actual leverage from API response
            liquidationPrice: asset.liquidationPrice, // Use the correct field from API response
            cumFunding: asset.cumFunding // Add cumulative funding
          }))
        };

        return <HyperliquidDetails hyperliquidData={hyperliquidData} onBack={() => window.history.back()} />;
      
      case 'okx':
        // Get all OKX-related assets (balances and positions)
        const okxAssets = state.assets.filter(asset => 
          asset.source.startsWith('okx')
        );
        
        return <OKXDetails okxData={okxAssets} />;
      
      case 'polymarket':
        return <PolymarketView />;
      
      default:
        // For other sources (binance, aster, defi), use the grouped view
        return <GroupedAssetView assets={sourceAssets} />;
    }
  };

  return (
    <div className="p-6">
      <h2 className="text-2xl font-bold text-gray-800 mb-6 capitalize">
        {source} Details
      </h2>
      
      {renderContent()}
    </div>
  );
};

export default DetailView;